import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type DevelopmentDetailsQueryVariables = Types.Exact<{
    id: Types.Scalars['Int'];
    deprecatedBranchId: Types.Scalars['Int'];
}>;

export type DevelopmentDetailsQuery = { __typename?: 'Query' } & {
    newHomesDevelopmentData?: Types.Maybe<
        { __typename?: 'NewHomesDevelopmentData' } & Pick<
            Types.NewHomesDevelopmentData,
            'bedrooms' | 'name' | 'images'
        > & {
                listingsDetails?: Types.Maybe<
                    { __typename?: 'ListingsDetails' } & {
                        listings?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'NewHomesListing' } & Pick<
                                        Types.NewHomesListing,
                                        | 'balcony'
                                        | 'parking'
                                        | 'terrace'
                                        | 'garage'
                                        | 'garden'
                                        | 'listingId'
                                        | 'propertyType'
                                        | 'section'
                                    > & {
                                            counts: {
                                                __typename?: 'RoomCount';
                                            } & Pick<
                                                Types.RoomCount,
                                                | 'numBathrooms'
                                                | 'numBedrooms'
                                                | 'numLivingRooms'
                                            >;
                                            pricing: {
                                                __typename?: 'ListingPricing';
                                            } & Pick<
                                                Types.ListingPricing,
                                                'label'
                                            >;
                                        }
                                >
                            >
                        >;
                    }
                >;
            }
    >;
};

export const DevelopmentDetailsDocument = gql`
    query DevelopmentDetails($id: Int!, $deprecatedBranchId: Int!) {
        newHomesDevelopmentData(
            id: $id
            deprecatedBranchId: $deprecatedBranchId
        ) {
            bedrooms
            name
            images
            listingsDetails {
                listings {
                    balcony
                    parking
                    terrace
                    garage
                    garden
                    counts {
                        numBathrooms
                        numBedrooms
                        numLivingRooms
                    }
                    pricing {
                        label
                    }
                    listingId
                    propertyType
                    section
                }
            }
        }
    }
`;

/**
 * __useDevelopmentDetailsQuery__
 *
 * To run a query within a React component, call `useDevelopmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      deprecatedBranchId: // value for 'deprecatedBranchId'
 *   },
 * });
 */
export function useDevelopmentDetailsQuery(
    baseOptions: Apollo.QueryHookOptions<
        DevelopmentDetailsQuery,
        DevelopmentDetailsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        DevelopmentDetailsQuery,
        DevelopmentDetailsQueryVariables
    >(DevelopmentDetailsDocument, options);
}
export function useDevelopmentDetailsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        DevelopmentDetailsQuery,
        DevelopmentDetailsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        DevelopmentDetailsQuery,
        DevelopmentDetailsQueryVariables
    >(DevelopmentDetailsDocument, options);
}
export type DevelopmentDetailsQueryHookResult = ReturnType<
    typeof useDevelopmentDetailsQuery
>;
export type DevelopmentDetailsLazyQueryHookResult = ReturnType<
    typeof useDevelopmentDetailsLazyQuery
>;
export type DevelopmentDetailsQueryResult = Apollo.QueryResult<
    DevelopmentDetailsQuery,
    DevelopmentDetailsQueryVariables
>;
